import { render, staticRenderFns } from "./VehicleBulbBadge.vue?vue&type=template&id=16033a1c"
import script from "./VehicleBulbBadge.vue?vue&type=script&lang=js"
export * from "./VehicleBulbBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports